'use client'

import type { CardFeature } from './types'

import parse from 'html-react-parser'

import { useIsMobile } from '@/hooks/useIsMobile'

function CardFeatures({ title, data }: { title?: string; data?: CardFeature[] }) {
  const isMobile = useIsMobile({ maxWidth: '576px' })

  return (
    <section
      className="section jumbotron"
      data-aos="zoom-in"
      data-aos-delay="200"
      style={{ paddingBottom: '8vh' }}
    >
      <div className="container">
        <div className="row">
          <div className="px-0 py-5">
            <h2 className="feature-title">{title && parse(title)}</h2>
            <div className="d-flex justify-content-between flex-wrap flex-column flex-sm-row">
              {data?.map((item: CardFeature, index: number) => {
                const isLast = index === data.length - 1
                const isEvenCount = data.length % 2 === 0

                return (
                  <div
                    key={item.title}
                    className="border p-4"
                    style={{
                      width: isMobile ? '100%' : isEvenCount ? '49%' : isLast ? '100%' : '49%',
                      marginBottom: isMobile ? '16px' : '30px',
                      borderRadius: '10px'
                    }}
                  >
                    <h3 className="mb-4 fs-4 fw-bold" style={{ color: 'var(--alrajhi-primary)' }}>
                      {item?.title}
                    </h3>
                    <p className="mb-0">{item?.description}</p>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CardFeatures
